import * as React from 'react';

import FileAudio16 from './FileAudio16';

export const fileAudio16 = () => <FileAudio16 />;

export default {
    title: 'Icon/Fill/FileAudio16',
    component: FileAudio16,
    parameters: {
        notes: "`import FileAudio16 from 'box-ui-elements/es/icon/fill/FileAudio16';`",
    },
};
